import {
  Box,
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getColor } from "../../../style/color/color";
import { Close } from "@mui/icons-material";
import TextInput from "../../../commanComponents/financialsnapshot/TextInput";
import Dropdown from "../../../commanComponents/financialsnapshot/Dropdown";
import deleteIcon from "../../../assets/icon/Group_33961.png";
import CustomSnackbar from "../../../commanComponents/CustomerSnackbar";

import "react-datepicker/dist/react-datepicker.css";
import { String } from "../../../constants/Strings";
import { fonts } from "../../../style/fonts/fonts";
const PolicyModel = ({ Title, open, handlClose, onSubmit, values }) => {
  const PolicyOptions = [
    { value: "Term Life", label: "Term Life" },
    { value: "Whole Life", label: "Whole Life" },
    { value: "ULIP", label: "ULIP" },
  ];

  const [cards, setCards] = useState([
    {
      policyType: PolicyOptions[0].value,
      coverageAmount: "",
      yearlyPremium: "",
    },
  ]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleAddMore = () => {
    setCards([
      ...cards,
      {
        policyType: "",
        coverageAmount: "",
        yearlyPremium: "",
      },
    ]);
  };
  useEffect(() => {
    if (values && Object.keys(values).length > 0) {
      setCards(
        values.map((card) => ({
          ...card,
          maturityDate: new Date().toLocaleDateString("en-GB"),
        }))
      );
    } else {
      setCards([
        {
          policyType: PolicyOptions[0].value,
          coverageAmount: "",
          maturityDate: new Date().toLocaleDateString("en-GB"),
          yearlyPremium: "",
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const handleFieldChange = (index, field, value) => {
    const newCards = [...cards];

    newCards[index][field] = value;

    if (field === "coverageAmount") {
      if (!/^\d+(\.\d+)?$/.test(value)) {
        setSnackbarMessage(
          String.Dashboard.Boxes.policy.totalAmountValidationMessage
        );
        setSnackbarOpen(true);
        return;
      }
    }

    setCards(newCards);
  };

  const handleDeleteCard = (index) => {
    if (cards.length > 1) {
      const newCards = cards.filter((_, cardIndex) => cardIndex !== index);
      setCards(newCards);
    }
  };
  const handleSave = () => {
    for (const card of cards) {
      if (!card.policyType || !card.coverageAmount || !card.yearlyPremium) {
        setSnackbarMessage(String.Dashboard.Boxes.Allfields);
        setSnackbarOpen(true);
        return;
      }
    }
    const formattedCards = cards.map((card) => ({
      ...card,
      maturityDate: new Date().toLocaleDateString("en-GB"),
    }));
    onSubmit(formattedCards);
    handlClose(false);
  };
  return (
    <Container sx={{ width: "100%", height: "100%" }}>
      <Dialog
        open={open}
        onClose={() => {
          handlClose(false);
        }}
        fullWidth
        sx={{
          width: "100%",
          maxWidth: "700px",
          height: "100%",

          overflowY: "auto",
          p: 1,
          "& .MuiPaper-root": {
            borderRadius: "16px",
          },
        }}
      >
        <DialogTitle
          sx={{
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: getColor.NeutralLightN60,
            textAlign: "center",
            position: "relative",
          }}
        >
          <Typography
            sx={{
              color: getColor.NeutralDark700,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              mt: "10px",
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            {Title}
          </Typography>
          <IconButton
            onClick={() => handlClose(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 2,
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            maxHeight: "400px",
            overflowY: "auto",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Box sx={{ mt: "40px", width: "100%", height: "100%" }}>
            {cards.map((card, index) => (
              <Card
                key={index}
                sx={{
                  width: "100%",
                  mb: 3,
                  p: 3,
                  position: "relative",
                  mt: "20px",
                  overflow: "visible",
                }}
              >
                <IconButton
                  onClick={() => handleDeleteCard(index)}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: getColor.red,
                    cursor: "pointer",
                  }}
                >
                  {" "}
                  <img src={deleteIcon} alt="delete" />
                </IconButton>
                <Dropdown
                  label="Type of Policy"
                  value={card.policyType}
                  onChange={(e) =>
                    handleFieldChange(index, "policyType", e.target.value)
                  }
                  options={PolicyOptions}
                />
                <TextInput
                  label="Coverage Amount"
                  value={card.coverageAmount}
                  type={"number"}
                  onChange={(e) =>
                    handleFieldChange(index, "coverageAmount", e.target.value)
                  }
                  inputPropss={true}
                />

                <TextInput
                  label="Yearly Premium"
                  value={card.yearlyPremium}
                  type={"number"}
                  onChange={(e) =>
                    handleFieldChange(index, "yearlyPremium", e.target.value)
                  }
                  inputPropss={true}
                />
              </Card>
            ))}
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", flexDirection: "column", p: 1, mt: "10px" }}
        >
          <Typography
            variant="body1"
            onClick={handleAddMore}
            color={getColor.red}
            sx={{
              fontSize: "1.2rem",
              mb: "20px",
              mt: "10px",
              cursor: "pointer",
            }}
            component={"div"}
          >
            + Add More
          </Typography>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              backgroundColor: getColor.ColorButtonPrimarysurface,
              width: "200px",
              mb: "20px",
              borderRadius: 4,
              textTransform: "inherit",
            }}
          >
            {String.Dashboard.Boxes.saveButton}
          </Button>
        </DialogActions>
      </Dialog>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={String.ErrorSeverity}
      />
    </Container>
  );
};

export default PolicyModel;
